import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { UserService } from '../../_services/user.service';
import { Subscription } from 'rxjs';
import { AngularFirestore } from 'angularfire2/firestore';

@Component({
  selector: 'app-silenced-user',
  templateUrl: './silenced-user.component.html',
  styleUrls: ['./silenced-user.component.css']
})
export class SilencedUserComponent implements OnInit {
  userId = this.userService.getUid();
  user: any;
  private subscription: Subscription = new Subscription();
  silencedUser: any;
  constructor(
    private cd: ChangeDetectorRef,
    private userService: UserService,
    private afs: AngularFirestore,
  ) {
    this.subscription.add(this.userService.getUser().subscribe(user => {
      this.user = user;
      try {
        this.subscription.add(this.afs.collection('users').doc(this.user.id).collection('silencedUser').valueChanges().subscribe((data => {
          if (data) {
            this.silencedUser = data;
            this.cd.markForCheck();

          }
          else {
            this.silencedUser = [];

          }

        })));
      } catch (e) {

        this.silencedUser = [];

      }
    }));
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  ngOnInit() {
  }

  delete(userKey) {

    this.afs.collection('users').doc(this.userId).collection('silencedUser').doc(userKey).delete();

  }

}



// WEBPACK FOOTER //
// C:/Users/Lenovo/Desktop/bigadvicefirestore/src/app/profile-update/silenced-user/silenced-user.component.ts